import { CustomRelation } from '@rossum/api-client/relations';
import { Url } from '@rossum/api-client/utils';
import { Chip, Stack } from '@rossum/ui/material';
import { SelectAnnotationParams } from '../../document-list-base/supportedAnnotationViews';
import { useCustomRelationsConfig } from '../hooks/useCustomRelationsConfig';

type CustomRelationBadgesProps = {
  annotationUrl: Url;
  customRelations: CustomRelation[];
  onOpenRelation?: (params: SelectAnnotationParams) => void;
};

export const CustomRelationBadges = ({
  annotationUrl,
  customRelations,
  onOpenRelation,
}: CustomRelationBadgesProps) => {
  const { allowedSubtypes } = useCustomRelationsConfig();

  const badges = customRelations.flatMap(relation => {
    const label = allowedSubtypes.find(
      subtype => subtype.name === relation.name
    )?.label;

    return label ? [{ relation, label }] : [];
  });

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      height={1}
      overflow="hidden"
    >
      {badges.map(({ relation, label }) => (
        <Chip
          key={relation.id}
          label={label}
          size="small"
          data-cy={`custom-relation-badge-${relation.id}`}
          onClick={event => {
            event.stopPropagation();
            onOpenRelation?.({
              annotationUrl,
              view: 'customRelation',
              relationId: relation.id,
            });
          }}
        />
      ))}
    </Stack>
  );
};
